import {
  Alert,
  Alignment,
  Button,
  Displaying,
  Primary,
  PRIMARY_COLOR,
  Spacing,
  Typography,
} from "@bonusx-global/bx-design-system";
import { ArrowUpRightOutlined, ChatQuestionSolid } from "@bonusx-global/bx-icons";
import styled from "@emotion/styled";
import Grid from "@mui/material/Grid";
import type { NoResultsAlertProps } from "../interfaces/NoResultsAlertProps";

const NoResultsAlertDesktopIconContent = styled(Grid)`
  display: ${Displaying.flex};
  align-items: ${Alignment.center};
  gap: ${Spacing[750]};
`;

export function NoResultsAlertMobile({ onClick }: Readonly<NoResultsAlertProps>): JSX.Element {
  return (
    <Alert icon={false} sx={{ bgcolor: Primary.light }} data-testid="no-search-result-alert-mobile">
      <Grid container gap={Spacing[750]} data-testid="no-search-result-alert-container">
        <NoResultsAlertDesktopIconContent item xs={12} data-testid="no-search-result-alert-content">
          <ChatQuestionSolid color={PRIMARY_COLOR} />
          <Typography variant="body2" color={Primary.dark}>
            Non ci sono bonus per te interessanti? Suggeriscili! Puoi anche indicare categorie o aree geografiche.
          </Typography>
        </NoResultsAlertDesktopIconContent>
        <Grid item xs={12}>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            fullWidth={true}
            endIcon={<ArrowUpRightOutlined />}
            onClick={onClick}
            data-testid="no-search-result-alert-button"
          >
            Suggerisci bonus
          </Button>
        </Grid>
      </Grid>
    </Alert>
  );
}
